import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-addusertoprojectdialog',
    templateUrl: './addusertoprojectdialog.component.html',
    styleUrls: ['./addusertoprojectdialog.component.scss'],
    standalone: false
})
export class AddusertoprojectdialogComponent {
  email: string = "";

  constructor(public dialogRef: MatDialogRef<AddusertoprojectdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EmailDialogData) { }

  addUser() {
    this.data.email = this.email;
    this.dialogRef.close(this.data);
   }

}

export interface EmailDialogData {
  email: string;
}